import { useContext } from "react";

// import { ClientSystemError, KBException } from "@/common/kb_exception";
// import { NowDateTimeDAO } from "@/dao/server/sk-server/nowdatetime/nowdatetime_dao";
import {
  ErrorDialogContext,
  errorHandledSync,
  errorHandledAsync,
} from "@/shared/context/error-context";
// import { Const, Mode } from "@/pages/receiving/components/modal/common/const";
import usePhotoShootStates from "@/features/accounts/ocr/hooks/photo-shoot-states";
import { OcrCameraAggregateModeType } from "@/shared/config/globals";

interface Props {
  setSelectedFiles: React.Dispatch<React.SetStateAction<File[]>>;
}

export const usePhotoShootController = (props: Props) => {
  const {
    setSelectedFiles,
  } = props;

  const {
    imageList,
    setImageList,
    previousScreen,
    setPreviousScreen,
    photoShootCount,
    setPhotoShootCount,
  } = usePhotoShootStates();

  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  // const nowDateTimeDAO = new NowDateTimeDAO();

  // 撮影した写真の追加
  const addImageList = async (image: string) => {
    // JSTの現在時刻を取得
    const getCurrentTimeStringJST = async () => {
      const padding = (number: number) => (number < 10 ? "0" + number : number);

      // const response = await nowDateTimeDAO.get();
      const nowDateTime = "2026-01-01 12:00:00"; // TODO: 仮の固定値。サーバーから取得する処理を実装すること

      const [dateString, timeString] = nowDateTime.split(" ");
      const [year, month, day] = dateString.split("-").map(Number);
      const [hours, minutes, seconds] = timeString.split(":").map(Number);

      // yyyymmddHHMMSS形式の文字列を作成
      return `${year}${padding(month)}${padding(day)}${padding(hours)}${padding(minutes)}${padding(seconds)}`;
    };

    const blob = window.atob(image.replace(/^.*,/, ""));
    const buffer = new Uint8Array(blob.length);
    for (let i = 0; i < blob.length; i++) {
      buffer[i] = blob.charCodeAt(i);
    }
    const file = new File([buffer.buffer], "image_" + (await getCurrentTimeStringJST()) + ".jpeg", {
      type: "image/jpeg",
    });

    // 画像ファイルのサイズチェック
    if (file.size > 20971520) {
      // throw new KBException({ error: ClientSystemError.SizeOverImageFileSelected });
    }

    setImageList((prev) => [...prev, image]);
    setSelectedFiles((prev) => [...prev, file]);

  };

  // 撮影した写真の一括削除
  const resetImageList = () => {
    setImageList([]);
    setSelectedFiles([]);
  };

  // 選択した写真の削除
  const deleteImageUrl = (num: number) => {
    setImageList((prev) => {
      const array = [...prev];
      array.splice(num, 1);
      return array;
    });
    setSelectedFiles((prev) => {
      const array = [...prev];
      array.splice(num, 1);
      return array;
    });
  };

  // 詳細画面に遷移する前に表示していた画面情報の設定
  const updatePreviousScreen = (mode: OcrCameraAggregateModeType) => {
    setPreviousScreen(mode);
  };

  // 撮影枚数の加算
  // NOTE：ヘッダーに表示されている枚数の更新と、imageListへの値の追加のタイミングが違うため、stateを使用して枚数を表示しています。
  const addPhotoShootCount = () => {
    setPhotoShootCount((prev) => prev + 1);
  };

  // 撮影枚数の減算
  const subtractionPhotoShootCount = () => {
    if (photoShootCount > 0) {
      setPhotoShootCount((prev) => Math.max(prev - 1, 0));
    }
  };

  // 撮影枚数のリセット
  const resetPhotoShootCount = () => {
    // setPhotoShootCount(0);
  };

  return {
    imageList,
    addImageList: errorHandledAsync(addImageList, setError),
    resetImageList: errorHandledSync(resetImageList, setError),
    deleteImageUrl: errorHandledSync(deleteImageUrl, setError),
    previousScreen,
    updatePreviousScreen: errorHandledSync(updatePreviousScreen, setError),
    photoShootCount,
    addPhotoShootCount: errorHandledSync(addPhotoShootCount, setError),
    subtractionPhotoShootCount: errorHandledSync(subtractionPhotoShootCount, setError),
    resetPhotoShootCount: errorHandledSync(resetPhotoShootCount, setError),
  };
};
